module.exports = __webpack_public_path__ + "static/img/7.bbc887e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/21/zh/7.png
// module id = SuMN
// module chunks = 0